/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

 /**
  * Dimensions for element size and its position relative to the viewport.
  */
export interface ElementDimensions {
  top: number;
  left: number;
  width: number;
  height: number;
}
